module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    class: _vm.catalogueItemClass(),
    on: {
      "mouseover": function($event) {
        _vm.onHoverProduct('enter');
      },
      "mouseleave": function($event) {
        _vm.onHoverProduct('leave');
      }
    }
  }, [_c('div', {
    staticClass: "item full center txtCenter"
  }, [_c('div', {
    staticClass: "preview"
  }, [_c('ComponentPreview', {
    attrs: {
      "component": _vm.item
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "rel"
  }, [_c('span', {
    staticClass: "ff-bold uppercase second-text"
  }, [(_vm.item.isStar) ? _c('i', {
    staticClass: "fas fa-star fa-1x pointer",
    style: ({
      color: _vm.colors.color4
    })
  }) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.getTranslate(_vm.item.terms.name)) + "\n                ")]), _vm._v(" "), _c('br')])], 1)]), _vm._v(" "), (_vm.device != 'mobile') ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.item.type + '/' + _vm.item.id
    }
  }, [(_vm.rollIndex === _vm.index) ? _c('div', {
    staticClass: "roll-over box-overlay flexContainer full"
  }, [_c('div', {
    staticClass: "txtCenter center"
  }, [_c('div', {
    staticClass: "hoverDetails"
  }, [_c('h4', {
    staticClass: "ff-medium uppercase"
  }, [(_vm.item.isStar) ? _c('i', {
    staticClass: "fas fa-star fa-1x pointer",
    style: ({
      color: _vm.colors.color4
    })
  }) : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.getTranslate(_vm.item.terms.name)) + "\n                        ")]), _vm._v(" "), (_vm.item.infosArticle.hasOwnProperty('client_ref1')) ? _c('p', {
    staticClass: "ff-light uppercase"
  }, [_vm._v("\n                            " + _vm._s(_vm.item.infosArticle.client_ref1.componentProperty.value) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.item.infosArticle.hasOwnProperty('diam_ref1')) ? _c('p', {
    staticClass: "ff-light uppercase"
  }, [_vm._v("\n                            " + _vm._s(_vm.item.infosArticle.diam_ref1.componentProperty.value) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.page == 'catalogue' && _vm.device != 'mobile') ? _c('div', {
    staticClass: "btn-hover txtCenter"
  }, [(_vm.item.type == 'module' || _vm.item.type == 'product') ? _c('span', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.addWishList();
      },
      "mouseenter": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.visibleinfo($event)
      },
      "mouseleave": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.hideinfo($event)
      }
    }
  }, [_c('i', {
    staticClass: "far fa-file-pdf fa-lg"
  })]) : _vm._e(), _vm._v(" "), (
    _vm.item.prices.find(function (p) { return p.zone.id === _vm.currentZoneId; }) != null &&
    _vm.item.type !== 'product' &&
    _vm.hasAccessRead('orders_manager')
  ) ? _c('span', {
    staticClass: "basket iLineBlock",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.openAddBasket();
      },
      "mouseenter": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.visibleBinfo($event)
      },
      "mouseleave": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.hideBinfo($event)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-basket fa-lg"
  })]) : _vm._e(), _vm._v(" "), (_vm.canAddToForecast() && _vm.hasAccessDelete(_vm.forecastFunctionality)) ? _c('span', {
    staticClass: "basket iLineBlock",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.displayForecastModal = true;
      },
      "mouseenter": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.displayForecast = true;
      },
      "mouseleave": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.displayForecast = false;
      }
    }
  }, [_c('ForecastIcon', {
    staticStyle: {
      "height": "20px",
      "margin-bottom": "-2px"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.displayinfo) ? _c('span', {
    staticClass: "info-export-pdf",
    class: {
      invisible: !_vm.displayinfo
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("catalogue.exportpdf")) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.displayBasketinfo) ? _c('span', {
    staticClass: "info-export-pdf",
    class: {
      invisible: !_vm.displayBasketinfo
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("catalogue.basket")) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.displayForecast) ? _c('span', {
    staticClass: "info-export-pdf"
  }, [_vm._v(" Add to Forecast ")]) : _vm._e()]) : _vm._e()])])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.displayForecastModal) ? _c('ForecastItemModal', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "close": function($event) {
        _vm.displayForecastModal = false;
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a46718da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ComponentListItem/ComponentListItem.vue
// module id = 3336
// module chunks = 0